"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExampleResultCardProduct = void 0;
const react_1 = __importDefault(require("react"));
const ExampleResultCardProduct = (props) => {
    return (react_1.default.createElement("div", { ref: props.itemRef, className: "rs__result-card-product" },
        react_1.default.createElement("a", { className: "rs__result-card-product__link", onClick: props.handleClick, href: `/products/${props.product.handle}` },
            props.product.image && (react_1.default.createElement("img", { className: "rs__result-card-product__image", src: props.product.image, width: "100%", height: "190px" })),
            react_1.default.createElement("span", { className: "rs__result-card-product__title" }, props.product.title)),
        react_1.default.createElement("span", { className: "rs__result-card-product__price" }, props.formattedPrice),
        props.onSale && (react_1.default.createElement("span", { className: "rs__result-card-product__price-sale", style: {
                textDecoration: "line-through",
            } }, props.formattedCompareAtPrice))));
};
exports.ExampleResultCardProduct = ExampleResultCardProduct;
//# sourceMappingURL=ExampleResultCardProduct.js.map